<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:left">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            <template v-if="item[0].length == 1">
                                                <template v-if="body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == ''">
                                                    -
                                                </template>
                                                <template v-else>
                                                        <template v-if="item == 'approve'">
                                                            <span v-if="body[item] == 'Y'" class="badge badge-success">Approve</span>
                                                            <span v-else class="badge badge-warning">Not Approve</span>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'hari'">
                                                                {{separatorHari(body[item])}}
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'tipePegawai'">
                                                                    <span v-if="body[item] == '1'">Pegawai</span>
                                                                    <span v-if="body[item] == '2'">TKO</span>
                                                                    <span v-if="body[item] == '3'">Magang</span>
                                                                    <span v-if="body[item] == '4'">PKL</span>
                                                                </template>
                                                                <template v-else>
                                                                    <span :title="body[item]">
                                                                        {{body[item]}}
                                                                    </span>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                            </template>
                                            <template v-if="item[0].length != 1">
                                                <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                    <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                                </a>
                                                <a v-else target="_blank" :href="body[item[0]]">
                                                    <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                                </a>
                                                {{body[item[1]]}}
                                            </template>
                                        </template>
                                        <template v-if="item == 'action'">
                                            <CButton @click="goEdit(id)" class="btn mr-1 btn-edit">Edit</CButton>
                                            <!-- <CButton @click="goDelete(id)" class="btn ml-1 btn-delete">Delete</CButton> -->
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action'">
                                        <template v-if="item[0].length == 1">
                                            <template v-if="body[item] == 'null' || body[item] == null || body[item] == undefined || body[item] == ''">
                                                -
                                            </template>
                                            <template v-else>
                                                    <template v-if="item == 'approve'">
                                                        <span v-if="body[item] == 'Y'" class="badge badge-success">Approve</span>
                                                        <span v-else class="badge badge-warning">Not Approve</span>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'hari'">
                                                            {{separatorHari(body[item])}}
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'tipePegawai'">
                                                                <span v-if="body[item] == '1'">Pegawai</span>
                                                                <span v-if="body[item] == '2'">TKO</span>
                                                                <span v-if="body[item] == '3'">Magang</span>
                                                                <span v-if="body[item] == '4'">PKL</span>
                                                            </template>
                                                            <template v-else>
                                                                <span :title="body[item]">
                                                                    {{body[item]}}
                                                                </span>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                        </template>
                                        <template v-if="item[0].length != 1">
                                            <a v-if="body[item[0]] == null || body[item[0]] == 'null' || body[item[0]] == '' || body[item[0]] == undefined">
                                                <img class="mr-2" :src="photo" width="32px" height="32px" style="border-radius:50%;background-color:#dcdcdc"/>
                                            </a>
                                            <a v-else target="_blank" :href="body[item[0]]">
                                                <img class="mr-2" :src="body[item[0]]" width="32px" height="32px" style="border-radius:50%"/>
                                            </a>
                                            {{body[item[1]]}}
                                        </template>
                                    </template>
                                    <template v-if="item == 'action'">
                                        <CButton @click="goEdit(id)" class="btn mr-1 btn-edit">Edit</CButton>
                                        <!-- <CButton @click="goDelete(id)" class="btn ml-1 btn-delete">Delete</CButton> -->
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            photo: require('@/assets/image/images.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        goDelete(id) {
            this.$emit('delete', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        separatorHari(value) {
            if(value == 1) {
                return 'Senin'
            } else if(value == 2) {
                return 'Selasa'
            } else if(value == 3) {
                return 'Rabu'
            } else if(value == 4) {
                return 'Kamis'
            } else if(value == 5) {
                return 'Jumat'
            } else if(value == 6) {
                return 'Sabtu'
            } else if(value == 7) {
                return 'Minggu'
            }
        }
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 20px;
    padding-right: 20px;
}
td,th {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    float: right;
    width: 80px;
    height: 32px;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    float:right;
    width: 80px;
    height: 32px;
}
.btn-delete {
    border-radius: 4px;
    border: 1px solid red;
    background-color: white;
    color: red;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
.btn-delete:hover {
    border-radius: 4px;
    border: 1px solid red;
    background-color: red;
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
}
</style>